import { ArtworkAuthenticationEditor } from "@/pages/cms/artwork-authentication";
import { CmsAdvancedLegacyFormShell } from "@/pages/cms/advanced/LegacyFormShell";
import { useCmsNew } from "@/lib/cms/cms-new-i18n";

/**
 * Section « Formulaire d'authentification » du CMS avancé
 * (`/cms/advanced/authentification`) : RÉUTILISE le formulaire d'authentification
 * d'œuvres de l'ancien CMS À L'INTÉRIEUR de la coquille avancée (une seule source
 * de vérité, `<form id="artwork-authentication">`). L'ancienne route
 * `/cms/artwork-authentication` reste en place.
 */
export default function CMSAdvancedAuthentication() {
  const cmsNew = useCmsNew();
  return (
    <CmsAdvancedLegacyFormShell
      title={cmsNew("cms.new.nav.authenticationForm", "Formulaire d'authentification")}
      formId="artwork-authentication"
    >
      <ArtworkAuthenticationEditor />
    </CmsAdvancedLegacyFormShell>
  );
}
